module.exports = __webpack_public_path__ + "img/C73524.f5e3c559.png";